import { ColumnsType } from 'antd/es/table';
import { EditFilled } from '@ant-design/icons';
import { AllReviewsProps } from '../../../types';
import dayjs from 'dayjs';
import { Button, Progress } from 'antd';
import { Paths } from '../../../routes';
import { PageLink, Status } from '../../../components';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { statusArray } from '../../../helper';
import { Typography } from 'antd';

const { Text } = Typography;

dayjs.extend(quarterOfYear);

export const columns = (
  onClick: (data: AllReviewsProps) => void
): ColumnsType => [
  {
    title: 'Name of Quarterly Review Cycle',
    key: 'name',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) => {
      return a.name?.trim().localeCompare(b.name?.trim());
    },
    render: (data) => (
      <PageLink
        label={data.name}
        id={data.id}
        path={Paths.EmployeesfortheQuarter}
        state={{
          from: 'hr',
          selectedCycleId: data.cycleId,
          id: data.id,
          isQuarter: true,
        }}
      />
    ),
  },
  {
    title: 'Review Quarter and Year',
    dataIndex: '',
    key: 'year',
    render: (data: AllReviewsProps) => {
      const startDate = dayjs(data.startDate);
      const year = startDate.year();
      const month = startDate.month() + 1; // getMonth() returns 0-11

      let quarter;
      if (year <= 2024) {
        if (month >= 1 && month <= 3) {
          quarter = 4;
        } else if (month >= 4 && month <= 6) {
          quarter = 1;
        } else if (month >= 7 && month <= 9) {
          quarter = 2;
        } else if (month >= 10 && month <= 12) {
          quarter = 3;
        }
      } else {
        quarter = startDate.quarter();
      }

      return <div>{`Q${quarter} - ${year}`}</div>;
    },
    sorter: (a: AllReviewsProps, b: AllReviewsProps) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
  },
  {
    title: 'Start Date',
    dataIndex: 'startDate',
    key: 'startDate',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'End Date',
    dataIndex: 'endDate',
    key: 'endDate',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) =>
      dayjs(a.startDate).diff(dayjs(b.startDate)),
    render: (date) => <div>{dayjs(date).format('MMM DD YYYY')}</div>,
  },
  {
    title: 'Quarterly Feedback Status',
    dataIndex: 'status',
    key: 'status',
    sorter: (a: AllReviewsProps, b: AllReviewsProps) => {
      const first = statusArray[Number(a.status)] || a.status;
      const next = statusArray[Number(b.status)] || b.status;
      return first.toString()?.trim().localeCompare(next?.trim());
    },
    render: (status) => <Status status={status} from="quarter" />,
  },
  {
    title: 'Progress',
    dataIndex: 'progress',
    key: 'progress',
    render: (progress, data) => {
      if (progress === 100 && data.status === 1) {
        return (
          <Progress
            percent={progress}
            format={() => <Text>{progress}%</Text>}
            strokeColor={'#1677ff'}
            size="default"
          />
        );
      } else {
        return <Progress percent={progress} size="default" />;
      }
    },
  },
  {
    title: 'Action',
    key: 'action',
    render: (data: AllReviewsProps) => {
      return (
        <div className="text-center">
          <Button
            disabled={data.status === 3}
            icon={<EditFilled />}
            onClick={() => onClick(data)}
          />
        </div>
      );
    },
  },
];
